/**
 * Lightweight frontend-only analytics helper.
 * Pushes events to `window.dataLayer` if Google Tag Manager / Analytics is
 * loaded, and logs to console in development. No new backend endpoints, no
 * new tables, no PII stored. Silent on any error to never affect UX.
 */
export function trackEvent(name, props = {}) {
    try {
        if (typeof window === "undefined") return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, ts: Date.now(), ...props });
        if (process.env.NODE_ENV !== "production") {
            // eslint-disable-next-line no-console
            console.debug("[analytics]", name, props);
        }
    } catch {
        /* silent — analytics must never break the app */
    }
}
